export default "__VITE_ASSET__CvcVIBTZ__"